import { LinkProps } from '@mui/material'
import { ButtonProps } from '@carto/meridian-ds/components'
import settings from 'settings'
import { ExternalLink } from '../ExternalLink'

const { documentationUrl } = settings

export default function DocLink({
  docUrl = '',
  children,
  useButton = false,
  baseUrl = documentationUrl,
  ...props
}: (LinkProps | ButtonProps) & { docUrl?: string; baseUrl?: string; showIcon?: boolean; useButton?: boolean }) {
  return (
    <ExternalLink href={`${baseUrl}${docUrl}`} {...props} useButton={useButton}>
      {children}
    </ExternalLink>
  )
}
